module.exports = __webpack_public_path__ + "img/emblem_2.d88f3ff7.svg";